"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigValue = exports.setPasportConfig = void 0;
let configUtils = undefined;
const minutes = (value) => {
    return value * 60 * 1000;
};
const setPasportConfig = (config) => {
    configUtils = {
        AUTH_TIMEOUT_INACTIVITY: minutes(15),
        AUTH_TIMEOUT_INACTIVITY_PROMPT_BEFORE: minutes(2),
        AUTH_TIMEOUT_BACK_IN_APP: minutes(45),
        AUTH_TIMEOUT_REFRESH_BEFORE_EXPIRATION: minutes(5),
        PANORAMA_FILES_BASE_PATH: `${config.COMMON_API_BASE_PATH}/files/panorama`,
        ...config,
    };
};
exports.setPasportConfig = setPasportConfig;
const getConfigValue = (key) => {
    if (!configUtils)
        throw new Error(`Pasport config is not set. ${key} is not available.`);
    return configUtils[key];
};
exports.getConfigValue = getConfigValue;
